module.exports = __webpack_public_path__ + "img/md-heart-dislike.aaeb7a8f.svg";